enum TravianVersion {
    Legends = 4,
    Kingdoms = 5,
}

export default TravianVersion;
